export const CAPACITIES = {
	ACCESS_MATRIX: {
		MANAGE: "ButterCapacity.MANAGE_ACCESS_MATRIX",
		READ: "ButterCapacity.ACCESS_MATRIX_RO"
	},
	ATTENDEES: {
		MANAGE: "ButterCapacity.MANAGE_ATTENDEE",
		RO: "ButterCapacity.ATTENDEE_RO"
	},
	CHECKLIST: {
		READ: "ButterCapacity.CHECKLIST_READ",
		ADD: "ButterCapacity.CHECKLIST_ADD",
		DELETE: "ButterCapacity.CHECKLIST_DELETE",
		EDIT: "ButterCapacity.CHECKLIST_EDIT",
		STRICT_MODE: "ButterCapacity.CHECKPOINT_STRICT_MODE",
		BETA: "ButterCapacity.BETA"
	},
	DEFAULT: {
		ADMIN: "ButterCapacity.ADMIN",
		OWNER: "ButterCapacity.OWNER"
	},
	DEVICE_STATUS: {
		READ: "ButterCapacity.DEVICE_STATUS_RO",
		MANAGE: "ButterCapacity.MANAGE_DEVICE_STATUS"
	},
	EVENT_CONFIG: {
		READ: "ButterCapacity.EVENT_CONFIG_READ",
		MANAGE: "ButterCapacity.EVENT_CONFIG_MANAGE"
	},
	INTEGRATIONS: {
		READ: "ButterCapacity.INTEGRATIONS_RO",
		MANAGE: "ButterCapacity.INTEGRATIONS"
	},
	SCANS_STATS: {
		READ: "ButterCapacity.SCAN_STATS_READ"
	},
	TEMPLATE: {
		MANAGE: "ButterCapacity.MANAGE_TEMPLATE",
		RO: "ButterCapacity.TEMPLATE_RO"
	},
	PYVAR: {
		ATTENDEE: "PyvarCapacity.ATTENDEE"
	},
	PARTNER: {
		ADVANCED_CONFIG: "ButterCapacity.ADVANCED_PARTNER_CONFIG"
	},
	PERIOD: {
		MANAGE: "ButterCapacity.MANAGE_PERIOD",
		READ: "ButterCapacity.PERIOD_RO"
	},
	POPULATION: {
		MANAGE: "ButterCapacity.MANAGE_POPULATION",
		READ: "ButterCapacity.POPULATION_RO"
	},
	ZONE: {
		MANAGE: "ButterCapacity.MANAGE_ZONE",
		READ: "ButterCapacity.ZONE_RO"
	}
};
